export abstract class Bootstrapper {
    /**
     * Perform a single stage of bootstrapping before Shopfront is initialised
     */
    public abstract bootstrap(): MaybePromise<void>;
}
